import {MenuItemAggregate} from '../../../../../aggregats/menu/menu-item.aggregate';
import {
  deconnexionSousMenuItem,
  mesParametresSousMenuItem,
  monCompteSousMenuItem,
} from './sous-menu-items.constantes';

export const profilMenuItem: MenuItemAggregate = new MenuItemAggregate('icon-user', 'Profil', [
  monCompteSousMenuItem,
  mesParametresSousMenuItem,
  deconnexionSousMenuItem,
]);
